import React from 'react'
import clx from 'classnames'
import { getCountryFlag } from '@/modules/shared/config/country-flag'

type Props = {
  size?: 'md' // 24 width x 16 height
  code: string
  className?: string
}

export const CountryFlag = (props: Props) => {
  const { code, className } = props

  return (
    <img
      className={clx('tw-mb-0 tw-mt-0 tw-h-[16px] tw-w-[24px]', className)}
      src={getCountryFlag(code)}
      width={24}
      height={16}
    />
  )
}
